import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'capitalize' })
export class CapitalizePipe implements PipeTransform {

  transform(value: string, args: 'capitalize' | 'camelCase' = 'capitalize') {
    if (value) {
      if (args === 'capitalize') {
        return value.charAt(0).toUpperCase() + value.slice(1);
      } else if (args === 'camelCase') {
        // separamos en un array por cada palabra, con el map pasamos a camelcase y luego con el join unimos en un solo string separado con un espacio
        return value.split(' ').map((x: string) => x.charAt(0).toUpperCase() + x.slice(1)).join(' ');
      }
    }
    return value;
  }

}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/utils/pipes/capitalize.ts